import React from 'react';

import { useGlobalState } from '~src/main/context/global-state';
import { useTranslate } from '~src/main/context/localization';
import { Heading } from '~src/main/ui/heading';
import { CategoryCard } from './category-card';
import { compareCategory } from './category-compare';
import { DisclaimerMessage } from '~src/main/ui/disclaimer-message';

export const CategoryManager: React.FC = () => {
  const tICU = useTranslate();
  const globalState = useGlobalState();

  const categories = globalState.delivery_categories
    // FIXME: hotfix - for now omit categories without carrier products
    .filter(category => category.default_prices.length > 0)
    .sort(compareCategory)
    .map(category => <CategoryCard key={category.id} category={category} />);

  return (
    <>
      <Heading>{tICU('widget.SHIPPING_CATEGORY_LIST_HEADER')}</Heading>
      <DisclaimerMessage message={globalState.disclaimer_message?.content} />
      {categories}
    </>
  );
};
